import { useEffect, useState } from "react";

const NAV = [
  { label: "今日热榜", href: "#hot" },
  { label: "大瓜精选", href: "#big" },
  { label: "分类速览", href: "#feed" },
  { label: "深度专题", href: "#topic" },
  { label: "吃瓜指南", href: "#about" },
  { label: "常见问题", href: "#faq" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="fixed inset-x-0 top-0 z-50">
      <div
        className={`transition-all duration-300 ${
          scrolled
            ? "bg-cream-50/90 backdrop-blur-md border-b border-cream-200/70 shadow-sm"
            : "bg-transparent border-b border-transparent"
        }`}
      >
        <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 md:px-6">
          <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-coral-500 text-lg text-white">
              <i className="ri-fire-line" aria-hidden="true"></i>
            </span>
            <span className="text-xl font-black tracking-tight text-stone-900">
              吃瓜<span className="text-coral-500">在线</span>
            </span>
          </a>

          <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                className="rounded-full px-3 py-2 text-sm font-medium text-stone-600 transition hover:bg-coral-50 hover:text-coral-600 whitespace-nowrap"
              >
                {n.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#contact"
              className="hidden whitespace-nowrap rounded-full bg-coral-500 px-4 py-2 text-sm font-semibold text-white transition hover:bg-coral-600 sm:inline-flex"
            >
              <i className="ri-quill-pen-line mr-1.5" aria-hidden="true"></i>我要爆料
            </a>
            <button
              type="button"
              aria-label={open ? "关闭菜单" : "打开菜单"}
              aria-expanded={open}
              onClick={() => setOpen((v) => !v)}
              className="flex h-10 w-10 items-center justify-center rounded-full text-xl text-stone-700 transition hover:bg-cream-200 lg:hidden"
            >
              <i className={open ? "ri-close-line" : "ri-menu-4-line"} aria-hidden="true"></i>
            </button>
          </div>
        </div>

        {open && (
          <div className="border-t border-cream-200 bg-cream-50 px-4 pb-4 pt-2 lg:hidden">
            <nav className="flex flex-col gap-1" aria-label="移动端导航">
              {NAV.map((n) => (
                <a
                  key={n.href}
                  href={n.href}
                  onClick={() => setOpen(false)}
                  className="flex items-center justify-between rounded-lg px-3 py-2.5 text-sm font-medium text-stone-700 transition hover:bg-coral-50 hover:text-coral-600"
                >
                  {n.label}
                  <i className="ri-arrow-right-s-line text-stone-400" aria-hidden="true"></i>
                </a>
              ))}
              <a
                href="#contact"
                onClick={() => setOpen(false)}
                className="mt-2 flex items-center justify-center whitespace-nowrap rounded-full bg-coral-500 px-4 py-2.5 text-sm font-semibold text-white"
              >
                <i className="ri-quill-pen-line mr-1.5" aria-hidden="true"></i>我要爆料
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}